import { LinkToNewTab } from "../../../Elements/Link/Link.js";
import Image from "../../../Elements/Image/Image.tsx";
import { DOMAIN_NAME } from "utils/globalConsts.ts";
import { useContent } from "contexts/contentContext/contentContext.js";

const EmbedPageFooter = ({ linkFooters }) => {
  const { getLanguage } = useContent();
  const baseUrl = window.location.origin.includes("localhost")
    ? `http://localhost:3000`
    : window.location.origin.includes("jumbomail") ||
      window.location.origin.includes("jmbl")
    ? window.location.origin
    : `https://${DOMAIN_NAME}`;

  return (
    <div className="embed-page-footer">
      <div className="footer-links">
        {linkFooters.map((item, i) => (
          <div key={i} className="footer-item">
            <LinkToNewTab isNewTab fullUrl={true} page={item.FooterLinkUrl}>
              {item.FooterLinkTitle}
            </LinkToNewTab>
          </div>
        ))}
      </div>
      <div className="powered-side">
        <LinkToNewTab
          isNewTab
          page={baseUrl + "/" +  getLanguage() + "/home"}
          fullUrl
          ariaLabel="home-page"
        >
          <Image name="jumbomail-logo-black" ext="svg" alt="" title="" />
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default EmbedPageFooter;
